import { z } from 'zod';
// =============================================================================
// Operator-sent announcements - kinds, audiences and statuses
// =============================================================================
/** Mirrors the `AnnouncementKind` Prisma enum; change both together, with a migration. */
export const ANNOUNCEMENT_KINDS = ['PRODUCT_ANNOUNCEMENT', 'SERVICE_NOTICE'];
export const AnnouncementKindSchema = z.enum(ANNOUNCEMENT_KINDS);
/** The notification type an announcement of each kind is raised as. */
export const ANNOUNCEMENT_KIND_TYPES = {
    PRODUCT_ANNOUNCEMENT: 'product-announcement',
    SERVICE_NOTICE: 'service-notice',
};
/** Mirrors the `AnnouncementAudience` Prisma enum; change both together, with a migration. */
export const ANNOUNCEMENT_AUDIENCES = ['ALL', 'ACCOUNTS'];
export const AnnouncementAudienceSchema = z.enum(ANNOUNCEMENT_AUDIENCES);
/**
 * Mirrors the `AnnouncementChannels` Prisma enum; change both together, with a migration.
 * `IN_APP` raises the bell notification only. `IN_APP_AND_EMAIL` also sends the email,
 * subject to each recipient's email preference for the category.
 */
export const ANNOUNCEMENT_CHANNELS = ['IN_APP', 'IN_APP_AND_EMAIL'];
export const AnnouncementChannelsSchema = z.enum(ANNOUNCEMENT_CHANNELS);
/** Mirrors the `AnnouncementStatus` Prisma enum; change both together, with a migration. */
export const ANNOUNCEMENT_STATUSES = ['DRAFT', 'SCHEDULED', 'DISPATCHING', 'DISPATCHED', 'CANCELLED'];
export const AnnouncementStatusSchema = z.enum(ANNOUNCEMENT_STATUSES);
